import { Subscription } from '@videoblocks/user-service-client';
import { subscriptionApi } from './userServiceConfig';

const getSubscriptionById = async (subscriptionId: string): Promise<Subscription> => {
    const result = await subscriptionApi.getSubscriptionById({ subscriptionId: subscriptionId });
    return result.data;
};

export const SubscriptionApi = {
    getSubscriptionById,
};